import findNextTabStop from '../../../htmlHelpers/findNextTabStop';
import { hasYesAttribute } from '../../utility/xmlHelpers';
import { ATTR_AUTO_ADVANCE } from '../view/view.attribute.names';

const nonEditKeys = [
    // control keys
    'Alt',
    'AltGraph',
    'Control',
    'CapsLock',
    'Fn',
    'FnLock',
    'NumLock',
    'ScrollLock',
    'Shift',
    'Insert',
    'Tab',
    // movement
    'ArrowDown',
    'Down',
    'ArrowLeft',
    'Left',
    'ArrowRight',
    'Right',
    'ArrowUp',
    'Up',
    'End',
    'Home',
    'PageDown',
    'PageUp',
    // deletion
    'Backspace',
    'Delete',
];

// KeyEvent -> Boolean
const isEditKeyPress = ({ key, altKey, ctrlKey }) =>
    !(nonEditKeys.includes(key) || altKey || ctrlKey);

// KeyEvent -> void
export const handleTextKeyUp = ($baseNode) => (ev) => {
    const { target } = ev;
    const { maxLength } = target;
    const autoAdvance = hasYesAttribute(ATTR_AUTO_ADVANCE, target);

    if (
        isEditKeyPress(ev) &&
        autoAdvance &&
        maxLength > -1 &&
        target.value.length >= maxLength
    ) {
        const nextControl = findNextTabStop($baseNode, target);

        if (nextControl) {
            nextControl.focus();
        }
    }
};
